import { gsap } from 'gsap';

export class QuickFacts {
  constructor() {}

  animateResult(element: HTMLElement) {
    const pieChart = element.querySelector('.pie-chart');
    const waveChart = element.querySelector('.wave-chart');
    let percentValue = '0%';

    if (pieChart && window.getComputedStyle(pieChart, null).display !== 'none') {
      const graph: HTMLElement = pieChart.querySelector('.pie-graph') as HTMLElement;

      const text: HTMLElement = pieChart.querySelector('.header-text') as HTMLElement;

      const percent: number = Number(graph?.dataset.percent);

      let animData = { percent: 0 };
      let percentString = `${100 - percent}%`;

      gsap.to(animData, {
        duration: 2,
        delay: 0.3,
        percent: percent,
        onUpdate: () => {
          text.textContent = `${Math.ceil(animData.percent)}%`;
        },
      });

      gsap.fromTo(
        graph,
        {
          background: `conic-gradient(#BADEEA 100%,#A5D2E1 0)`,
        },
        {
          duration: 1,
          delay: 0.3,
          background: `conic-gradient(#BADEEA ${percentString},#A5D2E1 0)`,
        }
      );
    }

    if (waveChart && window.getComputedStyle(waveChart, null).display !== 'none') {
      const wave: HTMLElement = waveChart.querySelector('.wave') as HTMLElement;
      const text: HTMLElement = waveChart.querySelector('.header-text') as HTMLElement;

      const percent: number = Number(wave?.dataset.percent);

      let animData = { percent: 0 };
      let percentString = `${100 - percent}%`;

      gsap.to(animData, {
        duration: 2,
        delay: 0.3,
        percent: percent,
        onUpdate: () => {
          text.textContent = `${Math.ceil(animData.percent)}%`;
        },
      });

      gsap.fromTo(
        wave,
        {
          yPercent: 100,
        },
        {
          duration: 1,
          delay: 0.3,
          yPercent: 100 - percent,
        }
      );
    }
  }
}
